module.exports = __webpack_public_path__ + "media/images/rekl-printing-7c12068bdbb70e807817088059e90124.jpg";